import React from 'react'
import { ReactComponent as Warning } from "../../assets/img/warning.svg"
import { ReactComponent as Cross } from "../../assets/img/cross.svg"


const ConfirmationModal = ({ handleModal, heading, message, handleConfirm, loading }) => {
    return (
        <div style={{ fontFamily: "Outfit", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <div
                className='d-flex flex-column justify-content-center align-items-center'
                style={{ backgroundColor: "#fff", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "30px 30px", width: "402px", position: "relative", maxHeight: '98vh', overflowY: 'auto', scrollbarWidth: "none" }}
            >
                <Warning />
                <h1 style={{
                    margin: '15px 0 10px 0',
                    fontWeight: 600,
                    fontSize: '24px',
                    fontFamily: "Outfit",
                    color: '#1C1C1C'
                }}>{heading}</h1>
                <span style={{
                    color: '#828282',
                    fontWeight: 400,
                    fontSize: '16px',
                    textAlign: "center",
                    width: "80%"
                }}>{message}</span>
                <div onClick={handleModal} className='vs-modal-close position-absolute' style={{
                    right: '20px',
                    top: '20px',
                }}>
                    <Cross />
                </div>
                <div className='flex-column w-100 align-items-center' style={{ display: "flex", justifyContent: "center", marginTop: "25px", gap: '10px' }}>
                    <button
                        className='vs-btn-save w-100'
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        Confirm
                    </button>
                    <button
                        className='vs-btn-cancel-alt w-100'
                        onClick={handleModal}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal